import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'footer-nav-coming-soon',
  templateUrl: './footer-nav-coming-soon.component.html',
  styleUrls: ['./footer-nav-coming-soon.component.scss']
})
export class FooterNavComingSoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
